<template>
	<div v-if="!is_weixin" class="ml-title" :style="`background-color: ${background}`">
		<div class="ml-title-text">{{title}}</div>
	</div>
</template>

<script>
import { is_weixin } from '../utils'
export default {
	data() {
		return {
			is_weixin: is_weixin()
		}
	},
	props: {
		title: {
			type: String,
			default: ""
		},
		background: {
			type: String,
			default: ""
		}
	},
	mounted() {
		// 微信环境 隐藏title
		if(is_weixin() || true) {
			document.title = this.title
		} else {

		}
	}
}
</script>

<style lang="scss" scoped>
.ml-title {
	z-index: 9;
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	height: .88rem;
	background-color: transparent;
	.ml-title-text {
		text-align: center;
		font-size: .36rem;
		line-height: .88rem;
		color: #fff;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/title/title.vue